import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import styles from './SpecialProgRequest.module.css';
import { patientActions, alertActions } from '_actions'
import { SaveButton, CancelButton } from '_components';

class PatientHomeAdmissionSpecialProgRequest extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            note: '',
            type: 'select',
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.saveRequest = this.saveRequest.bind(this);
        this.hideRequest = this.hideRequest.bind(this);
    }

    handleChange(event) {
        this.setState({ note: event.target.value });
    }

    handleTypeChange(event) {
        this.setState({ type: event.target.value });
    }


    saveRequest(event) {
        var msgs = [];
        if (this.state.type === 'select')
            msgs = [...msgs, 'Requested Program'];
        if (!this.state.note)
            msgs = [...msgs, 'Details'];
        if (msgs.length > 0) {
            this.props.alertError('The following fields are required: ' + msgs.join(', '));
        } else {
            this.props.saveRequest(this.props.id, parseInt(this.state.type), this.state.note);
        }

    }

    hideRequest(event) {
        this.props.hideRequest({ epno: this.props.id });
        this.setState({ note: '', type: 'select' });
    }

    render() {
        return (
            <div className={styles.request_wrapper}>
                <div className={styles.request_header}>
                    <span className={styles.type_label}>Requested Program:</span>
                    <select className={styles.type_dropdown} defaultValue="select" onChange={this.handleTypeChange}>
                        <option key={-1} value="select" disabled>Select a type...</option>

                        {Object.keys(this.props.types)
                            .map(id => {
                                const type = this.props.types[id];
                                return (
                                    <option key={type.STNO} value={type.STNO}>{type.STNAME}</option>
                                );
                            })
                        }
                    </select>
                </div>
                <div className={styles.details_header}>Details:</div>
                <div className={styles.request_body}>
                    <div className={styles.request_input}>
                        <textarea
                            autoFocus
                            name="note"
                            type="text"
                            className={styles.request}
                            rows="3"
                            value={this.state.note} onChange={this.handleChange}
                            placeholder='Please enter details regarding why you feel this patient would be a fit for the requested specialty program.'
                        />
                    </div>
                    <div className={styles.request_buttons}>
                        <span className={styles.request_button}><SaveButton onClick={this.saveRequest} /></span>
                        <span className={styles.request_button}><CancelButton onClick={this.hideRequest} /></span>
                    </div>
                </div>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        hideRequest: bindActionCreators(patientActions.hideSpecialProgReq, dispatch),
        saveRequest: bindActionCreators(patientActions.saveSpecialProgReq, dispatch),
        alertError: bindActionCreators(alertActions.error, dispatch)
    };
}


function mapStateToProps(state, ownprops) {
    return {
        types: Object.keys(state.entities.masterData.PRMASTERSPECIALPROGTYPES)
            .sort((a, b) => state.entities.masterData.PRMASTERSPECIALPROGTYPES[b].STNAME > state.entities.masterData.PRMASTERSPECIALPROGTYPES[a].STNAME ? -1 : 1)
            .map(key => state.entities.masterData.PRMASTERSPECIALPROGTYPES[key]),

    };
}

const connectedPatientHomeAdmissionSpecialProgRequest = connect(mapStateToProps, mapDispatchToProps)(PatientHomeAdmissionSpecialProgRequest);
export { connectedPatientHomeAdmissionSpecialProgRequest as PatientHomeAdmissionSpecialProgRequest };

